import React from 'react';

import Ecommerce from './ecommerce/Ecommerce';
import fallbackDictionary from './fallbackDictionary';
import Regions from './regions/Regions';
import Status from './status/status';
import { AccessInfo, CardControlLoader, CardRule, Piwik, SiteCoreDictionary } from './types';

import './RegionBlockForm.scss';

interface RegionBlockFormProps {
    cardControlLoader: CardControlLoader;
    cardRule: CardRule;
    handleEcommerceChange: (enabled: boolean) => void;
    handleRegionRuleChange: (regionId: string, enabled: boolean) => void;
    accessInfo: AccessInfo;
    sitecoreDictionary?: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const RegionBlockForm = ({
    cardControlLoader,
    cardRule,
    handleEcommerceChange,
    handleRegionRuleChange,
    accessInfo,
    sitecoreDictionary,
    piwik,
}: RegionBlockFormProps) => {
    const dictionary: SiteCoreDictionary = { ...fallbackDictionary, ...sitecoreDictionary };

    return (
        <div
            className="block-region-wrapper"
            data-track-id={piwik?.regionBlockEcommerce?.regionBlockAndEcommerceForm?.dataTrackId}
            data-track-linkname={piwik?.regionBlockEcommerce?.regionBlockAndEcommerceForm?.dataTrackLinkname}
            id={piwik?.regionBlockEcommerce?.regionBlockAndEcommerceForm?.dataTrackId}
        >
            <section aria-labelledby="Regionsperre">
                <Ecommerce
                    cardControlLoader={cardControlLoader}
                    cardRule={cardRule}
                    handleEcommerceChange={handleEcommerceChange}
                    accessInfo={accessInfo}
                    dictionary={dictionary}
                    piwik={piwik}
                />
                <Regions
                    cardControlLoader={cardControlLoader}
                    cardRule={cardRule}
                    handleRegionRuleChange={handleRegionRuleChange}
                    accessInfo={accessInfo}
                    dictionary={dictionary}
                    piwik={piwik}
                />
                <Status cardControlLoader={cardControlLoader} piwik={piwik} />
            </section>
        </div>
    );
};

export default RegionBlockForm;
